import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=baf3adf0&scoped=true&"
var script = {}
import style0 from "./Supplier.vue?vue&type=style&index=0&id=baf3adf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf3adf0",
  null
  
)

export default component.exports